export default __webpack_public_path__ + "static/media/B777.d33a0361.webp";